import React from 'react';
import { resolveRegionStyle } from './popupImagePreviewLogic';
import classes from './PopupImagePreview.module.scss';

interface PopupImagePreviewProps {
  imageURL: string
  top: string
  width: string
  height: string
}

export function PopupImagePreview(props: PopupImagePreviewProps) {
  const {
    imageURL, top, width, height,
  } = props;

  if (!imageURL) {
    return null;
  }

  const regionStyle = resolveRegionStyle(top, width, height);

  return (
    <div data-testid="popup-image-preview-canvas" className={classes.popupImagePreviewCanvas}>
      <img
        src={imageURL}
        alt="Offer popup"
        className={classes.popupImagePreviewImg}
      />
      <div className={classes.popupImagePreviewOverlay}>
        <div
          data-testid="popup-image-preview-region"
          className={classes.popupImagePreviewRegion}
          style={regionStyle}
        />
      </div>
    </div>
  );
}
